import { render, staticRenderFns } from "./PrizeDescription.vue?vue&type=template&id=9305b4f2&"
import script from "./PrizeDescription.vue?vue&type=script&lang=js&"
export * from "./PrizeDescription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9305b4f2')) {
      api.createRecord('9305b4f2', component.options)
    } else {
      api.reload('9305b4f2', component.options)
    }
    module.hot.accept("./PrizeDescription.vue?vue&type=template&id=9305b4f2&", function () {
      api.rerender('9305b4f2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/prize/pool/components/PrizeDescription.vue"
export default component.exports